import { Layouts } from '.';

const routes = [
  {
    path: '/',
    container: 'Home',
    layout: Layouts.EMPTY,
    noRedirect: true,
  },
  {
    path: '/consent',
    container: 'Consent',
    layout: Layouts.APP_LAYOUT,
  },
  {
    path: '/jira/callback',
    container: 'JiraCallback',
    layout: Layouts.APP_LAYOUT,
  },
  {
    path: '/privacy',
    container: 'Privacy',
    layout: Layouts.APP_LAYOUT,
    noRedirect: true,
  },
  {
    path: '/terms',
    container: 'Terms',
    layout: Layouts.APP_LAYOUT,
    noRedirect: true,
  },
  {
    path: '/cookies',
    container: 'Cookies',
    layout: Layouts.APP_LAYOUT,
    noRedirect: true,
  },
  {
    path: '/select-instance',
    container: 'ChooseInstance',
    layout: Layouts.APP_LAYOUT,
    requiresAuth: true,
  },
  {
    path: '/projects/:cloudId',
    container: 'ProjectsPicker',
    layout: Layouts.APP_LAYOUT,
    requiresAuth: true,
  },
  {
    path: '/projects/:cloudId/:projectId',
    container: 'Project',
    layout: Layouts.APP_LAYOUT,
    requiresAuth: true,
  },
  {
    path: '/500',
    container: 'ErrorPage',
    layout: Layouts.APP_LAYOUT,
    noRedirect: true,
  },
  {
    path: '/demo',
    container: 'Demo',
    layout: Layouts.APP_LAYOUT,
    noRedirect: true,
  },
];

export default routes;
